import {FocusTrap} from './focus-trap';

const responsiveToggle = (toggle) => {
  if (!toggle) {
    console.warn( 'Responsive toggle element not found.' );
    return;
  }

  const vars = window.acato_variables || {};
  const elements = {
    translateOverlay: document.querySelector( '.header__translate' ),
    translateButtonHeader: document.querySelector( '.translate-open' ),
    translateButtonMenu: document.querySelector( '.menu-translate-open' ),
    menuClose: document.querySelector( '.menu-close' ),
    mainMenu: document.querySelector( '.header__main-nav' ),
  };
  const focusTrap = new FocusTrap( elements.mainMenu );

  const toggleMenuState = (isOpen) => {
    focusTrap[isOpen ? 'enable' : 'disable']();
    toggle.setAttribute( 'aria-expanded', isOpen );
    toggle.classList.toggle( 'show', isOpen );
    hideTranslateOverlay();
  };

  const hideTranslateOverlay = () => {
    if (window.innerWidth > 880 && elements.translateOverlay && elements.translateButtonMenu && elements.translateButtonHeader) {
      elements.translateOverlay.classList.remove( 'open' );
      elements.translateButtonMenu.setAttribute( 'aria-expanded', false );
      elements.translateButtonHeader.setAttribute( 'aria-expanded', false );
    }
  }

  const toggleMainMenu = () => {
    const isOpen = !elements.mainMenu.classList.contains( 'show' );
    document.body.classList.toggle( 'header-menu-open', isOpen );
    elements.mainMenu.classList.toggle( 'show', isOpen );
    toggleMenuState( isOpen );
    if (!isOpen) {
      toggle.focus();
    }
  };

  const handleKeyEvent = (event) => {
    if (event.key === 'Escape') {
      event.preventDefault();
      if (elements.mainMenu.classList.contains( 'show' )) {
        toggleMainMenu();
      }
    }
  };

  const closeMenuOnToggleShiftTab = (event) => {
    if (event.key === 'Tab' && event.shiftKey) {
      if (elements.mainMenu.classList.contains( 'show' )) {
        toggleMainMenu();
      }
    }
  }

  toggle.addEventListener( 'click', toggleMainMenu );
  toggle.addEventListener( 'keydown', closeMenuOnToggleShiftTab );
  elements.menuClose?.addEventListener( 'click', toggleMainMenu );
  elements.mainMenu?.addEventListener( 'keydown', handleKeyEvent );
};

export default responsiveToggle;